import { AppRoute } from '@/config/routes';
import { Container } from '@/ui/components/Container/Container';
import { WorkshopsCard } from '@/ui/landing-v2/components/WorkshopsCard/WorkshopsCard';
import { I18nNamespaces } from '@/utils/i18n.namespaces';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import styles from './Hero.module.scss';

export const Hero = () => {
  const router = useRouter();
  const { t } = useTranslation(I18nNamespaces.Homepagev2);
  return (
    <div className={styles.container}>
      <div className={styles.image}></div>
      <Container>
        <div className={styles.header}>
          <h2 className={styles.title}>
            {t('workshops.hero.title')}
          </h2>
          <h4 className={styles.subtitle}>
            {t('workshops.hero.subtitle')}
          </h4>
        </div>
        <div className={styles.cardsWrapper}>
          <WorkshopsCard
            imageUrl={'/images/landing-v2/github-icon.webp'}
            title={t('section.checkWorkshops.workshop1.title')}
            firstContent={t(
              'section.checkWorkshops.workshop1.description1'
            )}
            secondContent={t(
              'section.checkWorkshops.workshop1.description2'
            )}
            workshopUrl={AppRoute.g.gitWorkshop}
          />
          <WorkshopsCard
            imageUrl={'/images/landing-v2/react-icon.webp'}
            title={t('section.checkWorkshops.workshop2.title')}
            firstContent={t(
              'section.checkWorkshops.workshop1.description1-1'
            )}
            secondContent={t(
              'section.checkWorkshops.workshop1.description2'
            )}
            workshopUrl={AppRoute.g.reactWorkshop}
          />
          <WorkshopsCard
            imageUrl={'/images/landing-v2/bun-icon.webp'}
            title={t('section.checkWorkshops.workshop3.title')}
            firstContent={t(
              'section.checkWorkshops.workshop1.description1'
            )}
            secondContent={t(
              'section.checkWorkshops.workshop1.description2'
            )}
            workshopUrl={AppRoute.g.bunExperiment}
          />
          <WorkshopsCard
            imageUrl={'/images/landing-v2/tests-icon.webp'}
            title={t('workshops.workshopVitest.title')}
            firstContent={t(
              'section.checkWorkshops.workshop1.description1'
            )}
            secondContent={t(
              'section.checkWorkshops.workshop1.description2'
            )}
            workshopUrl={AppRoute.g.vitest}
          />
          <WorkshopsCard
            imageUrl={'/images/landing-v2/checkers-icon.webp'}
            title={t('workshops.workshopCheckers.title')}
            firstContent={t(
              'section.checkWorkshops.workshop1.description1-2'
            )}
            secondContent={t(
              'section.checkWorkshops.workshop1.description2'
            )}
            workshopUrl={AppRoute.g.devMentor}
          />
        </div>
      </Container>
    </div>
  );
};
